<template lang="pug">
  #MemberSearchIndex
    .content-header.bg-secondary.rounded-bottom-1rem.d-flex.align-items-center
      h5.mb-0 顧客查詢
    .container-width
      b-form-group.mx-3.mt-3.mb-1.text-gray
        b-form-select.border-0(
          id="card_type",
          required,
          v-model="store",
          style="padding-right:3rem; border-radius: 20px;background-color: #eee;"
        )
          template(
            v-slot:first
          )
            b-form-select-option(
              :value="null",
              disabled
            ) 請選擇櫃點
          b-form-select-option(
            v-for="(store,index) in personnelStore",
            :key="`${store.id}_${store.id}`",
            :value="store.id"
          ) {{ store.title }}
      .p-3
        b-form-group.mb-2.text-gray(
          label="顧客姓名"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.chinese_last_name",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-2.text-gray(
          label="會員卡號"
        )
          b-input-group
            b-form-input.border-0(
              v-model="searchInput.code",
              style="border-radius: 20px;background-color: #eee;"
            )
        b-form-group.mb-3.text-gray(
          label="會員會籍"
        )
          b-form-select.border-0(
            id="card_type",
            required,
            v-model="searchInput.card_type",
            style="border-radius: 20px;background-color: #eee;"
          )
            template(
              v-slot:first
            )
              b-form-select-option(
                :value="null",
                disabled
              ) 請選擇會籍
            b-form-select-option(
              v-for="(level,index) in memberLevelList",
              :key="`${level}_${index}`",
              :value="level.role"
            ) {{ level.name }}
        b-form-group.mb-3.text-gray(
          label="會員生日"
        )
          .d-flex.align-items-center
            b-form-select.border-0(
              v-model="searchInput.birthdayMonth",
              style="border-radius: 20px;background-color: #eee;"
            )
              template(
                v-slot:first
              )
                b-form-select-option(
                  :value="null",
                  disabled
                ) 請選擇月份
              b-form-select-option(
                v-for="index in 12",
                :value="index"
              ) {{ index }}
            span.px-2 月
            b-form-select.border-0(
              v-model="searchInput.birthdayDate",
              style="border-radius: 20px;background-color: #eee;"
            )
              template(
                v-slot:first
              )
                b-form-select-option(
                  :value="null",
                  disabled
                ) 請選擇日期
              b-form-select-option(
                v-for="index in 31",
                :value="index"
              ) {{ index }}
            span.px-2 日
        .row.no-gutters.justify-content-center
          .col-5.pl-1
            b-button.font-weight-bold.btn-custom(
              variant="primary",
              block,
              @click="searchHandler()",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
            ) 搜尋
</template>

<script>
import { mapState } from 'vuex';
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import { SIC_MEMBER_SEARCH_SHOW } from '@/router/sic/member-search';

export default {
  name: 'MemberSearchIndex',
  components: {
    ProfilePhotoSticker
  },
  data() {
    return {
      searchInput: {
        chinese_last_name: null,
        code: null,
        card_type: null,
        birthdayMonth: null,
        birthdayDate: null
      },
      selectMode: false,
      selectUsers: [],
      infiniteId: +new Date(),
      store: null
    };
  },
  created() {
    const vm = this;
    vm.$store.commit('toggleLoading', false);
    vm.$store.commit('sa_member_search/resetHandler');
    vm.$swal.fire({
      title: '載入中，請稍候',
      allowOutsideClick: false,
      willOpen: () => {
        this.$swal.showLoading();
      }
    });
    vm.$store.dispatch('sa_member_search/getMemberLevelListHandler')
      .then(() => {
        vm.$swal.close();
      });
  },
  methods: {
    infiniteHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '搜尋中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      vm.$store.dispatch('sic_member_search/getMemberListHandler', {
        store_id: vm.store,
        chinese_last_name: vm.searchInput.chinese_last_name,
        code: vm.searchInput.code,
        card_type: vm.searchInput.card_type,
        birthday: vm.searchInput.birthdayMonth && vm.searchInput.birthdayDate ? `${ vm.searchInput.birthdayMonth.toString().padStart(2,'0') }-${ vm.searchInput.birthdayDate.toString().padStart(2,'0') }` : null,
        per_page: 999999
      }).then(() => {
        vm.$swal.close();
        vm.$router.push({ name: SIC_MEMBER_SEARCH_SHOW });
      });
    },
    searchHandler() {
      const vm = this;
      if (vm.store === null) {
        vm.$swal.fire({
          icon: 'error',
          title: '請選擇櫃點'
        });
        return;
      }
      if((vm.searchInput.birthdayMonth && !vm.searchInput.birthdayDate) || (!vm.searchInput.birthdayMonth && vm.searchInput.birthdayDate)) {
        vm.$swal.fire({
          icon: 'error',
          title: '會員生日需完整填寫',
        });
        return;
      }
      vm.$store.commit('sic_member_search/resetHandler');
      vm.infiniteHandler();
    }
  },
  computed: {
    ...mapState({
      memberList: (state) => state.sa_member_search.memberList,
      cardTypeOptions: (state) => state.sa_member_search.cardTypeOptions,
      memberLevelList: (state) => state.sa_member_search.memberLevelList,
      personnelStore: (state) => state.sic_stores_manager.personnelStoreData
    })
  }
};
</script>

<style lang="scss" scoped>
.searchArea {
  &__iconArrow {
    position: absolute;
    right: 10px;
    top: 5px;
    outline: none;
    transform: rotate(0deg);
    transition: all .3s;
  }
  &__iconArrow.collapsed {
    transform: rotate(180deg);
  }
}

.ProfilePhotoSticker {
  border: 0.2rem solid #000!important;
}
select {
  background-image: url(../../../assets/images/icon/arrow-dropdown-1.png);
  background-repeat: no-repeat;
  background-size: 1rem;
  background-position: center right 1.2rem;
}
.custom-select:focus {
  outline: 0;
  box-shadow: 0 0 0 0;
}
</style>
